import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { DimmerOverlay } from "./Modal.styles";
import type { ModalDimmerProps } from "./Modal.types";

/**
 * Standalone / shorthand dimmer surface. When used as `dimmer={<ModalDimmer />}`,
 * the root Modal clones it around the dialog.
 */

const ModalDimmerComponent = (props: ModalDimmerProps): ReactElement => {
  const { children, content, inverted, className, style, onClick } = props;
  return (
    <DimmerOverlay
      className={cx(className)}
      style={style}
      $inverted={inverted}
      onClick={onClick}
      role="presentation"
    >
      {children ?? content}
    </DimmerOverlay>
  );
};

export const ModalDimmer = styled(ModalDimmerComponent)``;
